import React, { useEffect, useState } from "react";

import "./stylesCustomDatePicker.css";

import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const generateDropdownClassName = () => {
  const baseClassName = "custom-dropdown-class";
  const randomSuffix = Math.random().toString(36).substring(2, 8);
  return `${baseClassName}-${randomSuffix}`;
};

function CustomDatePicker({
  getData,
  dates,
  setDates,
  showPresets = false,
  startRange = "Today",
}) {
  const [open, setOpen] = useState(false);
  const [selectedPreset, setSelectedPreset] = useState(startRange);

  const popupClassName = generateDropdownClassName();

  const quickRanges = [
    { label: "Today", value: [dayjs(), dayjs()] },
    {
      label: "Yesterday",
      value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
    },
    {
      label: "This Week",
      value: [dayjs().startOf("week"), dayjs().endOf("week")],
    },
    {
      label: "Prior Week",
      value: [
        dayjs().subtract(1, "week").startOf("week"),
        dayjs().subtract(1, "week").endOf("week"),
      ],
    },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "Prior Month",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
  ];

  useEffect(() => {
    // const presetList = document.querySelector(".ant-picker-presets ul"); //include dropDownClassName
    const presetList = document.querySelector(
      `.${popupClassName} .ant-picker-presets ul`
    );
    if (presetList) {
      const listItems = presetList.querySelectorAll("li");
      listItems.forEach((li) => li.classList.remove("selected"));
      const selectedIndex = quickRanges.findIndex(
        (p) => p.label === selectedPreset
      );
      if (listItems[selectedIndex]) {
        listItems[selectedIndex].classList.add("selected");
      }
    }
  }, [selectedPreset, open]);

  return (
    <div className="custom-datepicker-container">
      <RangePicker
        value={dates}
        onChange={(values) => {
          setOpen(false);
          let matchedPreset = null;

          if (!values) {
            matchedPreset = quickRanges.find(
              (preset) => preset.label === startRange
            );
          } else {
            matchedPreset = quickRanges.find(
              (preset) =>
                values[0].isSame(preset.value[0], "day") &&
                values[1].isSame(preset.value[1], "day")
            );
          }

          if (matchedPreset) {
            setSelectedPreset(matchedPreset.label);
          }

          let queryString = "";
          if (values) {
            queryString = `start_date=${values[0].format(
              "YYYY-MM-DD"
            )}&end_date=${values[1].format("YYYY-MM-DD")}`;
            setDates(values);
          } else {
            queryString = `start_date=${matchedPreset.value[0].format(
              "YYYY-MM-DD"
            )}&end_date=${matchedPreset.value[1].format("YYYY-MM-DD")}`;
            setDates(matchedPreset.value);
          }
          getData(queryString);
        }}
        open={open}
        onOpenChange={setOpen}
        presets={showPresets ? quickRanges : []}
        popupClassName={popupClassName}
      />
    </div>
  );
}

export default CustomDatePicker;
